module.exports = __webpack_public_path__ + "static/media/safari-logo.904e1076.png";